/* OVESSI language chip positioner v11
   Chip stays inside .header__icons (Shopify keeps putting it back there).
   We position chip absolutely relative to its actual offsetParent, using
   the wordmark's viewport rect as the anchor.
   - Mobile: top = wordmark.bottom + 2 (close to logo)
   - Desktop: top = wordmark.bottom + 6
   - Horizontal: dead-centre on wordmark midpoint
*/
(function () {
  'use strict';

  function findWordmark(scope) {
    var link = (scope || document).querySelector('.header__heading-link');
    if (link && link.getBoundingClientRect().width > 0) return link;
    return null;
  }

  function positionChip(chip) {
    var wordmark = findWordmark(document);
    if (!wordmark) return false;
    var wRect = wordmark.getBoundingClientRect();
    if (wRect.width === 0) return false;

    // Determine offsetParent (the element absolute positioning resolves against).
    // Force position:relative on chip's parent if it's static, so positioning is
    // predictable relative to the immediate parent.
    var parent = chip.parentElement;
    if (!parent) return false;
    if (getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }
    var pRect = parent.getBoundingClientRect();

    var isMobile = window.innerWidth < 750;
    var gap = isMobile ? 2 : 6;
    var top = (wRect.bottom - pRect.top) + gap;
    var centerX = (wRect.left + wRect.right) / 2 - pRect.left;

    chip.style.position = 'absolute';
    chip.style.top = top + 'px';
    chip.style.left = centerX + 'px';
    chip.style.right = 'auto';
    chip.style.transform = 'translateX(-50%)';
    chip.style.margin = '0';
    chip.style.zIndex = '5';
    return true;
  }

  function setup() {
    var chip = document.querySelector('.ovessi-lang');
    if (!chip) return;

    chip.classList.add('ovessi-lang--ready');

    function apply() {
      // Re-query chip in case Shopify section reload swapped DOM
      var liveChip = document.querySelector('.ovessi-lang');
      if (!liveChip) return;
      liveChip.classList.add('ovessi-lang--ready');
      positionChip(liveChip);
    }

    apply();
    requestAnimationFrame(apply);
    [30, 100, 300, 700, 1500, 3000].forEach(function (t) { setTimeout(apply, t); });
    window.addEventListener('resize', apply, { passive: true });
    window.addEventListener('orientationchange', apply);
    window.addEventListener('load', apply);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
    document.addEventListener('shopify:section:load', apply);
    document.addEventListener('shopify:section:reorder', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
